import { gql } from 'graphql-request';
import type { GqlSonCategoryScore } from 'src/app/portfolio/state/api/portfolioStateOfNatureQuery';
import type { SiteStatus } from './siteStatus';

export type GqlSonFactor = {
    sourceKey: string;
    name: string;
    band: 'VERY_GOOD' | 'GOOD' | 'MODERATE' | 'POOR' | 'VERY_POOR';
    weight: number;
};

export type GqlSiteSonCategoryScore = Omit<GqlSonCategoryScore, 'factors'> & {
    factors: GqlSonFactor[];
};

export const siteStateOfNatureQuery = gql`
    query GetSiteStateOfNature($organisationBusinessCentralId: String!, $siteId: ID!, $at: DateTime) {
        site(organisationBusinessCentralId: $organisationBusinessCentralId, siteId: $siteId, at: $at) {
            id
            name
            status
            validTo
            geography {
                countryName
            }
            activity {
                isicDetail {
                    code
                    description
                }
            }
            riskSummary {
                stateOfNature
            }
            sonCategoryBreakdown {
                sourceKey
                name
                score
                band
                factors {
                    sourceKey
                    name
                    band
                    weight
                }
            }
        }
    }
`;

export type SiteStateOfNatureResult = {
    site: {
        id: string;
        name: string;
        status: SiteStatus;
        validTo: string | null;
        geography: {
            countryName: string | null;
        } | null;
        activity: {
            isicDetail: { code: string; description: string } | null;
        } | null;
        riskSummary: {
            stateOfNature: number | null;
        } | null;
        sonCategoryBreakdown: GqlSiteSonCategoryScore[];
    } | null;
};
